import { __makeTemplateObject } from "tslib";
import MuiAppBar from '@material-ui/core/AppBar';
import { palette2, styled } from '../../foundation';
var TOP_BAR_HEIGHT = '56px';
var RcAppBar = styled(MuiAppBar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  background-color: ", ";\n  background: linear-gradient(\n    to right,\n    ", ",\n    ", "\n  );\n  border-bottom: 1px solid ", ";\n  z-index: ", ";\n"], ["\n  height: ", ";\n  background-color: ", ";\n  background: linear-gradient(\n    to right,\n    ", ",\n    ", "\n  );\n  border-bottom: 1px solid ", ";\n  z-index: ", ";\n"])), TOP_BAR_HEIGHT, palette2('neutral', 'b01'), palette2('header', 'bgLeft'), palette2('header', 'bgRight'), palette2('header', 'divider'), function (_a) {
    var theme = _a.theme;
    return "" + (theme.zIndex.drawer + 10);
});
RcAppBar.displayName = 'RcAppBar';
RcAppBar.defaultProps = {
    position: 'static',
    elevation: 0,
};
export { RcAppBar };
var templateObject_1;
